import React from 'react';

export default () => {
  return <div>Please install Plugin for smooth use.</div>;
};
